import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/utils/util.service';
import { DailyService } from '../../dailyservices/daily.service';

@Component({
  selector: 'app-subjectline',
  templateUrl: './subjectline.component.html',
  styleUrls: ['../../../../../app.component.css']
})
export class SubjectlineComponent implements OnInit {
  tabId = 0;
  tabs: any[] = [];
  activeIndex: number;
  checkPreviousTab = false;
  constructor(private service: DailyService, private utilService: UtilService) { }
  ngOnInit(): void {
    this.activeIndex = 0;
    this.tabs = this.service.subjectLineTabs;
    // this.changeDetector.detectChanges();
  }
  addTabInArray(tabObject) {
    if (tabObject) {
      // Checking Whether The Tab is in the Array or Not
      const index = this.service.subjectLineTabs.findIndex(x => (x.header === tabObject.header && x.type === tabObject.type));
      if (index !== -1) {
        // Update Tab in Tab Array
        this.service.subjectLineTabs.splice(index, 1, {
          id: this.tabId + 1,
          header: tabObject.header,
          type: tabObject.type,
          isClosable: true,
          startDate: tabObject.startDate,
          endDate: tabObject.endDate,
          data: tabObject.data
        });
        this.activeIndex = index;
      } else {
        // Adding New Tab in Tab Array
        this.service.subjectLineTabs.push({
          id: this.tabId + 1,
          header: tabObject.header,
          type: tabObject.type,
          isClosable: true,
          startDate: tabObject.startDate,
          endDate: tabObject.endDate,
          data: tabObject.data
        });
        // localStorage.setItem("platformTabs", JSON.stringify(this.service.subjectLineTabs));
        this.activeIndex = this.service.subjectLineTabs.length - 1;
      }
    }
  }
  // Close Tab and remove from the Tab Array
  closeTab(tabIndex) {
    this.service.subjectLineTabs.splice(tabIndex, 1);
    // localStorage.setItem("platformTabs", JSON.stringify(this.service.subjectLineTabs));
    this.activeIndex = this.service.subjectLineTabs.length - 1;
  }

  // Adjust Viewport According to Sidenav Expand and Collapse
  isExpanded() {
    return this.utilService.isExpanded;
  }
}
